// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-layout {
  min-height: 100vh;
  background: var(--color-bg);
}

.list-content {
  padding: 24px 0;
  min-height: calc(100vh - 200px);
}

.content-container.list-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

.list-title {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #2d3436;
  text-align: center;
}

.games-main {
  width: 100%;
}

.games-grid {
  margin-top: 24px;
  margin-bottom: 40px;
}

.fade-in {
  animation: fadeIn 0.5s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ad-in-list {
  margin: 20px 0;
  padding: 16px;
  background: var(--color-bg-white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  text-align: center;
}

.ad-in-list .ad-container {
  margin: 0;
}

.ad-in-list .ad-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 90px;
}

.scroll-loading-container {
  text-align: center;
  padding: 20px 0;
  margin: 20px 0;
}

.loading-text {
  margin-top: 12px;
  color: #666;
  font-size: 14px;
}

@media (max-width: 768px) {
  .list-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .list-content {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  .content-container.list-container {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0 16px;
  }

  .list-title {
    font-size: 24px;
    margin-bottom: 16px;
  }

  .games-grid {
    margin-top: 16px;
  }

  .games-main {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 24px 0;
  }
}

@media (max-width: 480px) {
  .content-container.list-container {
    padding: 0 12px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/List/List.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".list-layout {\n  min-height: 100vh;\n  background: var(--color-bg);\n}\n\n.list-content {\n  padding: 24px 0;\n  min-height: calc(100vh - 200px);\n}\n\n.content-container.list-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  width: 100%;\n}\n\n.list-title {\n  font-size: 28px;\n  font-weight: 600;\n  margin-bottom: 24px;\n  color: #2d3436;\n  text-align: center;\n}\n\n.games-main {\n  width: 100%;\n}\n\n.games-grid {\n  margin-top: 24px;\n  margin-bottom: 40px;\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.ad-in-list {\n  margin: 20px 0;\n  padding: 16px;\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-sm);\n  text-align: center;\n}\n\n.ad-in-list .ad-container {\n  margin: 0;\n}\n\n.ad-in-list .ad-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 90px;\n}\n\n.scroll-loading-container {\n  text-align: center;\n  padding: 20px 0;\n  margin: 20px 0;\n}\n\n.loading-text {\n  margin-top: 12px;\n  color: #666;\n  font-size: 14px;\n}\n\n@media (max-width: 768px) {\n  .list-layout {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .list-content {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .content-container.list-container {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding: 0 16px;\n  }\n\n  .list-title {\n    font-size: 24px;\n    margin-bottom: 16px;\n  }\n\n  .games-grid {\n    margin-top: 16px;\n  }\n\n  .games-main {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 24px 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .content-container.list-container {\n    padding: 0 12px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
